const PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
export const prefersReducedMotion = ()=>window.matchMedia(PREFERS_REDUCED_MOTION_QUERY).matches;
